import { useLocale } from 'hooks';
import type { HTMLProps } from 'react';

const MESSAGE = {
    fa: 'محتوایی یافت نشد',
    en: 'No Content Provided',
}

interface IProps extends HTMLProps<HTMLDivElement> {
    message?: string;
}

export default function NoContent({ message, ...rest }: IProps) {
    const { locale } = useLocale();
    return <div className='tw-text-base xxxl:tw-text-xl tw-text-center tw-bg-white tw-w-full tw-p-4 tw-rounded-lg' {...rest}>{message || MESSAGE[locale]}</div>
}